import PropTypes from 'prop-types';
import {
  FooterContainer,
  FooterTitle,
  FooterSubTitle,
  FooterContent,
  FooterCard,
  FooterImage,
  FooterCardCover,
  FooterCardDesc,
  FooterCardCount,
  BookClassButon,
  FooterCover,
  FooterCardTitle
} from './styles';

const Footer = ({ scrollRef, stats }) => {
  const { title, subTitle, key, resources } = stats;
  const handleScroll = () => {
    scrollRef.current.scrollIntoView({ behaviour: 'smooth', block: 'end' });
  };
  return (
    <FooterContainer>
      <FooterCover>
        <FooterTitle>{title}</FooterTitle>
        <FooterSubTitle>{subTitle}</FooterSubTitle>
        <BookClassButon type="button" $display="md" onClick={handleScroll}>
          {key}
        </BookClassButon>
      </FooterCover>
      <FooterContent>
        {resources.map((_resource, id) => (
          <FooterCard key={_resource.id} $id={id}>
            <FooterCardCover>
              <FooterCardTitle>{_resource.title}</FooterCardTitle>
              <FooterCardDesc>{_resource.subTitle}</FooterCardDesc>
              <FooterCardCount>+</FooterCardCount>
            </FooterCardCover>
            <FooterImage src={_resource.url.default} alt={_resource.title} />
          </FooterCard>
        ))}
      </FooterContent>
      <BookClassButon type="button" $display="sm" onClick={handleScroll}>
        Get started
      </BookClassButon>
    </FooterContainer>
  );
};

Footer.propTypes = {
  scrollRef: PropTypes.objectOf(PropTypes.any).isRequired,
  stats: PropTypes.objectOf(PropTypes.any).isRequired
};

export default Footer;
